import tippy, { hideAll } from 'tippy.js'
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';

document.addEventListener('alpine:init', () => {
    window.addEventListener('close-messages-history-modal', () => hideAll({ duration: 0 }));

    Alpine.magic('tooltip', el => (message, trigger = 'mouseenter focus') => {
        let instance = el._tippy ?? tippy(el, {trigger, allowHTML: true, theme: 'light', placement: 'top'})
        instance.setContent(message)

        if (trigger === 'manual') {
            instance.show()

            setTimeout(() => {
                instance.hide()

                setTimeout(() => instance.destroy(), 150)
            }, 2000)
        }
    })

    Alpine.directive('tooltip', (el, {expression, modifiers}, {evaluateLater, effect, cleanup}) => {
        const js = modifiers.includes('js');
        const delay = modifiers.includes('delay');
        const touch = modifiers.includes('touch');

        const placementIndex = modifiers.indexOf("placement");
        const placement = placementIndex !== -1 && modifiers[placementIndex + 1] ? modifiers[placementIndex + 1] : "top";

        const evaluate = js ? evaluateLater(expression) : null;

        const trigger = touch ? 'click' : 'mouseenter focus';

        const instance = el._tippy ?? tippy(el, {
            allowHTML: true,
            theme: 'light',
            placement,
            trigger,
            delay: delay ? [400, 0] : 0,
            maxWidth: 550,
            touch,
            hideOnClick: touch ? true : undefined,
            onShow(instance) {
                hideAll({ exclude: instance });
            }
        });

        cleanup(() => el._tippy?.destroy());

        effect(() => {
            if (el._tippy) {
                if (evaluate) {
                    evaluate(content => {
                        if (_.isEmpty(content)) {
                            instance.destroy();
                            return;
                        }

                        el._tippy.setContent(content);
                    });
                    return;
                }

                if (_.isEmpty(expression)) {
                    instance.destroy();
                    return;
                }

                el._tippy.setContent(expression);
            }
        })
    })
})
